import React from "react";

const JourneyTimeline = ({ journey }) => {
  return (
    <section className="bg-gray-100 py-20">
      <div className="text-center mb-12">
        <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-2">
          Our Journey
        </h2>
        <div className="mx-auto w-24 h-1 bg-orange-500 rounded mb-2"></div>
      </div>
      <div className="relative w-full max-w-3xl mx-auto flex flex-col items-center">
        {/* Vertical line */}
        <div className="absolute left-1/2 top-0 h-full w-1 bg-orange-400 -translate-x-1/2 z-0" />
        <div className="w-full flex flex-col gap-12 pt-4 z-10">
          {journey.map((item, idx) => (
            <div
              key={item.year}
              className={`flex w-full ${
                idx % 2 === 0 ? "justify-start -m-4" : "justify-end m-4"
              }`}
            >
              <div
                className="w-full max-w-sm bg-white rounded-xl shadow-md p-6 mb-2 border border-gray-100"
                style={{
                  marginLeft: idx % 2 === 0 ? 0 : "auto",
                  marginRight: idx % 2 === 0 ? "auto" : 0,
                }}
              >
                <h3 className="text-xl font-bold text-orange-500 mb-2">
                  {item.year}
                </h3>
                <p className="text-gray-700 text-base">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default JourneyTimeline;
